import _ from 'lodash';
import slug from 'slug';

import { removeTeacherLastName } from 'utils/helperFunctions';

import { TEACHERS_LOADING, TEACHERS_SUCCESS, TEACHERS_ERROR } from '../actions/teacherActions';


const INITIAL_STATE = {};

export default function teachersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TEACHERS_LOADING:
      return { ...state, status: 'loading' };

    case TEACHERS_SUCCESS:
      // add a slug to each teacher
      const teacherData = _.map(action.payload.data.data, teacher => {
        // remove last name from teacher name
        teacher.name = removeTeacherLastName(teacher.name);

        teacher.slug = teacher.name ? slug(teacher.name).toLowerCase() + '-' + teacher.id : null;

        return teacher;
      });

      // return an object from the incoming array with the
      // id as the key for each record
      return _.mapKeys(teacherData, 'id');

    case TEACHERS_ERROR:
      const { status, statusText } = action.payload.response;
      const { message } = action.payload;

      return { error: { status, statusText, message } };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/teachersReducer.js